import { httpClient } from 'shared/lib'
import { CategoriesType } from './types'

export function fetchCategories() {
   return httpClient
      .get<CategoriesType>('categories')
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('empty response')
      })
      .catch((err) => {
         throw new Error(err.message)
      })
}
